export const MAKE_SET_SEO = 'make/init/seo'; // 初始化书本信息变量
export const MAKE_INIT_SEO = 'make/init/seo'; // 初始化书本信息变量
export const MAKE_GET_SEO = 'get/init/seo'; // 初始化书本信息变量


export const MAKE_INIT_EMPTY = 'book/init/empty'; // 初始化书本信息变量
export const MAKE_INIT = 'book/init'; // 初始化书本信息

export const LOCAL_USER = 'local/user'; // 获取本地用户信息

export const SET_BOOKINFO = 'set/bookInfo'; // 设置书本基本信息
export const SET_BOOKLIST = 'set/bookList'; // 设备书本内页数组
export const SET_TYPEINFO = 'set/typeInfo'; // 设置类型信息
export const SET_LEAVEIMAGES = 'set/leaveImages'; // 设置该书的闲置照片数组
export const SET_PAGE_TEXT = 'set/page/text'; // 更新书本的文字部分
export const SET_PAGE_IMAGE = 'set/page/image'; // 更新书本的图片部分 
export const SET_UNINSTALL_IMAGES = 'set/uninstall/image'; // 卸载图片 
export const SET_UNINSTALL_QRCODE_IMAGES = 'set/uninstall/qrcode/image'; // 卸载图片 
export const SET_NEW_MODULE = 'set/new/module'; // 修改版面样式
export const SET_BOOK_NAME = 'set/book/name'; // 修改书名
export const SET_BOOK_UPDATE = 'set/book/update'; // 修改书本保存状态
export const DEL_LEAVE_IMAGE = 'del/leave/image'; // 删除闲置图片
export const MAKE_PAGE_UP = 'make/page/up'; // 将页面上移
export const MAKE_PAGE_DOWN = 'make/page/down'; // 将页面下移 
export const MAKE_PAGE_DEL = 'make/page/del'; // 删除页面
export const MAKE_PAGE_ADD = 'make/page/add'; // 添加页面
export const MAKE_PAGE_JOIN = 'make/page/join'; // 执行添加页面
export const SAVE_BOOK_DATA = 'save/book/data'; // 保存数据
export const SAVE_LEAVE_DATA = 'save/leave/data'; // 保存成功后 将删除状态的图片剔除

export const GET_BOOKINFO = 'get/bookInfo'; // 获取书本基本信息
export const GET_BOOKLIST = 'get/bookList'; // 获取书本内页数组
export const GET_TYPEINFO = 'get/typeInfo'; // 获取类型信息
export const GET_KEEPBOOKES = 'get/keepBooks'; // 获取保存状态
export const GET_LEAVEIMAGES = 'get/leaveImages'; // 获取该书的闲置照片数组 
export const GET_LEAVEIMAGES_ALL = 'get/leaveImages/all'; // 设置该书的闲置照片数组

export const USER_LOGIN = 'user/login'; // 用户登录
export const LOGIN_SMS = 'login/sms'; // 获取登录验证码 
export const SAVE_LOCALUSER = 'save/localuser'; // 获取登录验证码 

// export const BOOK_INIT = 'book/init'; // 初始化编辑的书本信息
// export const BOOK_INIT_EMPTY = 'book/init/empty'; // 初始化编辑的书本信息


// WEBPACK FOOTER //
// ./src/store/types.js